<template>
    <a href @click.prevent="confirm" v-tooltip.bottom="'Excluir'" class="btn-floating btn-flat btn-transparent">
        <i class="material-icons text-default">delete</i>
    </a>
</template>

<script>

import { api } from '@/helpers/api';
import swal from 'sweetalert2';

import modal from "@/helpers/wm-modal";
import Message from '@/helpers/message';

export default {
    components: { Message },
    props: ['url', 'identificador'],
    methods: {
        async confirm() {
            let self = this;

            const result = await modal.confirm({
                title: "Tem certeza que deseja excluir?",
                text: "Você não terá mais acesso a esse registro!",
            })


            if (! result) return;

            const {data: {result: {data}}} = await api.delete(self.url);

            Message.messageSuccess('Removido com sucesso!');

            this.$emit('deleted', data)

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/BotaoRemover.vue